import { render, staticRenderFns } from "./christmasLogo.vue?vue&type=template&id=4a4ebc94"
import script from "./christmasLogo.vue?vue&type=script&lang=js"
export * from "./christmasLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports